import React from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import MissionValuesSection from './components/MissionValuesSection';
import AchievementsSection from './components/AchievementsSection';
import WhyESBSection from './components/WhyESBSection';
import ProductPortfolioSection from './components/ProductPortfolioSection';
import GlobalPartnershipsSection from './components/GlobalPartnershipsSection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

const Homepage = () => {
  return (
    <div className="min-h-screen bg-background transition-colors duration-300">
      <Header />
      
      <main className="pt-16">
        <HeroSection />
        <div className="space-y-24 lg:space-y-32">
          <AboutSection />
          <ProductPortfolioSection />
          <MissionValuesSection />
          <AchievementsSection />
          <WhyESBSection />
          <GlobalPartnershipsSection />
          {/* <TestimonialsSection /> */}
          <ContactSection />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Homepage;